
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[[...path]]",
      function () {
        return require("private-next-pages/c/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[[...path]]"])
      });
    }
  